import { error } from '@sveltejs/kit';
import type { SeoMeta } from '$lib/seo';
import { postBySlug, POSTS, type PostMeta } from '$content/notes/posts';
import type { PageLoad } from './$types';

/**
 * Prerender every essay slug — published and scheduled. Scheduled slugs
 * still render a real letter (per spec: "no JS redirect, no 404, no
 * email capture; the page sits and waits"). Returning the post object
 * tells the page how to render.
 */
export const entries = (): Array<{ slug: string }> => POSTS.map((p) => ({ slug: p.slug }));

export const load: PageLoad = ({ params }) => {
	const post = postBySlug(params.slug);
	if (!post) throw error(404, 'No such letter.');

	const seo: SeoMeta = {
		title: post.title,
		description: post.description,
		path: `/notes/${post.slug}/`,
		pageType: 'WebPage',
		article:
			post.status === 'published' && post.publishedAt
				? {
						datePublished: post.publishedAt,
						readingTimeMinutes: post.readingTimeMinutes
					}
				: undefined
	};

	return { seo, post: post as PostMeta };
};
